export enum FUIAlertType {
    ERROR,
    WARNING,
    SUCCESS,
    INFORMATION,
    CONFIRMATION
}

export interface FUIAlertAction {
    name: string;
    label: string;
    inputs?: {};
}

export enum FUIAlertInputType {
    TEXT,
    TEXT_AREA
}

export interface FUIAlertInput {
    type: FUIAlertInputType;
    name: string;
    label: string;
    required: boolean;
}

export interface FUIAlert {
    title: string;
    message: string;
    params: Object;
    type: FUIAlertType;
    actions: FUIAlertAction[];
    inputs?: FUIAlertInput[];
}

export class FUIAlertActions {
    public static readonly OK_ACTION: FUIAlertAction = {name: "ok", label: "fui.alert.button.ok"};
    public static readonly CANCEL_ACTION: FUIAlertAction = {name: "cancel", label: "fui.alert.button.cancel"};
    public static readonly YES_ACTION: FUIAlertAction = {name: "yes", label: "fui.alert.button.yes"};
    public static readonly NO_ACTION: FUIAlertAction = {name: "no", label: "fui.alert.button.no"};
}
